import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { taOptions } from 'textangular';
import * as _ from 'underscore';
import { HttpService } from '../../../../../app.common/modules/api/http.service';
import { BlobService } from '../../../../../app.common/modules/common/services/blob.service';
import { HtmlService } from '../../../../../app.common/modules/common/services/html.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { WysiwygService } from '../../../../../app.common/modules/common/services/wysiwyg.service';
import { ClassificationCategoriesService } from '../../../../../app.retailer.common/modules/categories/classification-categories.service';
import { CommonCampaignsService } from '../../../../../app.retailer.common/modules/services/commonCampaigns.service';
import { RetailerService } from '../../../api/retailer.service';
import { AudienceResourceOfferModel, Campaign, InformationCardListItem } from '../../../core';
import { IRetailerRootScope } from '../../../core/models';
import { InformationCardsService } from '../../../informationCards/informationCards.service';
import { NfcRetailerStickersService } from '../../../nfc-stickers/nfc-retailer-stickers.service';
import { ShopService } from '../../../places/shop.service';
import { INfcStickersErrors } from '../../../products/models';
import { CreateEditCampaignBase } from '../../controllers/createEditCampaignBase.controller';
import {
    ICampaign,
    ICampaignInformationCardLink,
    ICampaignProductLink,
    ICampaignVideoRetailerMessage
} from '../../models';
import { CampaignsService } from '../../services/campaigns.service';
import { ISearchInformationCardItem } from './../../models/index';

export class CreateEditMarketingCampaignController extends CreateEditCampaignBase {
    public static $inject = [
        '$rootScope', '$scope', '$timeout', 'commonCampaignsService',
        'campaignsService', 'popupService', 'notificationService',
        'htmlService', 'appWysiwygOptions', 'wysiwygService', '$q', 'shopService',
        'classificationCategoriesService', '$uibModal', '$translate', 'retailerService',
        'FileUploader', 'http', 'blobService', 'nfcRetailerStickersService', '$localStorage', 'informationCardsService'];

    public isRetailerCampaign = true;
    public isCopy: boolean = null;
    public isEdit: boolean = null;
    public isNew: boolean = null;
    public countryID: number;

    public htmlTooltip = {
        jispExclusivity: this.$translate.instant('tooltip_jisp_exclusivity'),
        campaignType: this.$translate.instant('tooltip_campaign_type'),
        geoTargeting: this.$translate.instant('tooltip_geo_targeting'),
        referralOffer: this.$translate.instant('tooltip_referral_offer'),
        videoProcessingTooltip: this.$translate.instant('tooltip_video_process')

    };

    protected audienceResource: AudienceResourceOfferModel = null;

    constructor(
        $rootScope: IRetailerRootScope,
        $scope: ng.IScope,
        $timeout: ng.ITimeoutService,
        commonCampaignsService: CommonCampaignsService,
        campaignsService: CampaignsService,
        popupService: PopupService,
        notificationService: NotificationService,
        htmlService: HtmlService,
        taOptions: taOptions,
        wysiwygService: WysiwygService,
        $q: ng.IQService,
        private shopService: ShopService,
        private classificationCategoriesService: ClassificationCategoriesService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        $translate: angular.translate.ITranslateService,
        retailerService: RetailerService,
        fileUploaderFactory: any, // FileUploaderFactory
        http: HttpService,
        blobService: BlobService,
        public nfcRetailerStickersService: NfcRetailerStickersService,
        private $localStorage: ngStorage.StorageService,
        private informationCardsService: InformationCardsService
    ) {
        super($rootScope, $scope, $timeout, commonCampaignsService, campaignsService, popupService, notificationService,
            htmlService, taOptions, wysiwygService, $translate, retailerService, fileUploaderFactory, $q, http, blobService);

        this.isCopy = !!this.ID && $rootScope.$state.current.name === 'app.marketing-campaigns.copy';
        this.isEdit = !!this.ID && $rootScope.$state.current.name === 'app.marketing-campaigns.edit';
        this.isNew = $rootScope.$state.current.name === 'app.marketing-campaigns.new-branded' || $rootScope.$state.current.name === 'app.marketing-campaigns.new-templated';

        $rootScope.$on('CampaignVideoProcessingFinish', (event, data: ICampaignVideoRetailerMessage) => this.onUpdateCampaignVideoProcessing(event, data));

        $rootScope.$on('CampaignVideoProcessingError', (event, data: ICampaignVideoRetailerMessage) => this.onUpdateCampaignVideoProcessing(event, data));
    }

    public async $onInit() {
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        try {
            const checkCanEditStickers = this.nfcRetailerStickersService.checkCanEditStickers();

            const result = await this.$q.all([
                this.isNew ? this.campaignsService.getDefaultCampaignModel(this.$rootScope.enums.CampaignType.Promotion) : this.campaignsService.getEditableCampaign(this.ID),
                this.campaignsService.getAudience(),
                this.nfcRetailerStickersService.getLocations({}),
                checkCanEditStickers as angular.IPromise<boolean>
            ]);
            this.notificationService.clearAll();
            this.campaign = result[0] as ICampaign;
            this.audienceResource = result[1] as AudienceResourceOfferModel;
            this.stores = result[2].Items;
            this.canEditStickers = result[3];
            this.audienceService.model = this.campaignsService.getAudienceModel(this.audienceResource, this.campaign.offerAudience);
            const promise = this.campaignsService.getCountry();
            promise.then((result) => {
                this.campaign.currencySign = result.CurrencySign;
            });

            if (this.campaign.image && this.campaign.campaignContentType === 2 || this.campaign.campaignContentType === 4) {
                this.imageCropped.isGif = this.campaign.campaignContentType === 4;
                this.imageCropped.imageUrl = this.campaign.image.imageUrl;
                if (this.imageCropped.isGif) {
                    const imgData = await this.blobService.getDataImageByUrl(this.campaign.image.imageUrl);
                    this.setImageCropped(imgData);
                } else {
                    this.imageCropped.src = this.campaign.image.imageUrl;
                }
            }

            if (this.campaign.video && this.campaign.campaignContentType === 3) {
                this.video = this.campaign.video;
                this.videos.push(this.video);

                this.videoManager.processing = ((this.campaign.videoStatus === this.videoStatus.Added) ||
                    (this.campaign.videoStatus === this.videoStatus.Uploaded) ||
                    (this.campaign.videoStatus === this.videoStatus.Processing));
                this.videoManager.processed = this.campaign.videoStatus === this.videoStatus.Processed;
                this.videoManager.processingError = this.campaign.videoStatus === this.videoStatus.ProcessingError;
            }

            if (this.campaign.statusModel.status === this.campaignStatus.Error) {
                this.campaignForm.$setDirty();
            } else {

                this.campaignForm.$setPristine();
            }

            if (this.isEdit && this.campaign.entityStatus === Campaign.EntityStatusEnum.NUMBER_5) {
                this.waiting = true;
                const time = 3000;
                this.notificationService.showErrorMessage({
                    body: this.$translate.instant('campaing_is_archived'),
                    timeout: time,
                });

                this.$timeout(() => {
                    if (window.history.state) {
                        window.history.back();
                    } else {
                        this.$rootScope.$state.go('app.marketing-campaigns.overview');
                    }
                }, time);
                this.waiting = true;
            }
            this.setHeightPanel();
        } catch (error) {
            this.notificationService.showErrorMessage(_.isString(error) ? error : error.message);
        }
        this.waiting = false;

        this.setHeightPanel();

        this.$scope.$watch('vm.isValidMandatoryFields()', (value: boolean, old: boolean) => {
            if (!value && old) {
                this.campaign.entityStatus = Campaign.EntityStatusEnum.NUMBER_1;
            }
        });

        this.$scope.$watch('vm.getCropImageDivWidth()', (width: number) => {
            if (width) {
                this.imageCropped.maxWidth = width;
            }
        });

        this.$scope.$watch('vm.imageCropped.croppedImage', (value: string) => {
            this.$timeout(() => { this.campaignsService.resizeFont(); });
            if (this.campaign && this.campaign.statusModel) {
                this.campaign.statusModel = this.getCampaignStatusModel();
            }
        });

        this.$scope.$watch('vm.video.videoID', (value: number) => {
            this.$timeout(() => { this.campaignsService.resizeFont(); });
            if (this.campaign && this.campaign.statusModel) {
                this.campaign.statusModel = this.getCampaignStatusModel();
            }
        });

        this.$scope.$watch('vm.campaign.type', (value: number) => {
            this.accordionOptions.scheduleGroupShow = !this.campaign.isExclusiveOffer && value !== this.campaignType.SpecialEvent;
        });

        this.$scope.$watch('vm.campaign.isExclusiveOffer', (value: boolean) => {
            this.accordionOptions.scheduleGroupShow = !value && this.campaign.type !== this.campaignType.SpecialEvent;
        });

        this.$scope.$watch('vm.campaign',
            () => {
                if (this.campaign && this.campaign.statusModel) {
                    this.campaign.statusModel = this.getCampaignStatusModel();
                }
            }, true);

        this.$scope.$watch('vm.accordion.designGroupOpen', (value: boolean) => {
            if (value === undefined) { return; }
            if (this.campaignForm.$pristine) {
                this.campaignForm.$setPristine();
            }
            if (value) {
                this.campaignsService.resizeFontWithTimeOut();
            }
        });

        this.initWatch();
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    }

    public async addProductLinks() {
        const promise = this.$uibModal.open({
            component: 'productSearch',
            resolve: {
                items: () => this.campaign.campaignProductLinks
            }
        });

        const result: ICampaignProductLink[] = await promise
            .result
            .catch(angular.noop);

        if (!result) {
            return;
        }

        this.campaign.campaignProductLinks = result;
        this.campaignForm.$setDirty();
    }

    public async addInfotagLinks() {
        const promise = this.$uibModal.open({
            component: 'infoCardSearch',
            resolve: {
                items: () => this.campaign.campaignInformationCardLinks
            }
        });

        const result: ISearchInformationCardItem[] = await promise
            .result
            .catch(angular.noop);
        if (!result) {
            return;
        }

        this.campaign.campaignInformationCardLinks = result.map((item) => ({
            ImageID: item.ImageID,
            InformationCardID: item.ID,
            Title: item.Title
        } as ICampaignInformationCardLink));
        this.campaignForm.$setDirty();
    }

    public getImageUrl(imageID: string) {
        return this.informationCardsService.getImageUrl(imageID, 60);
    }

    public removeProductLink(link: ICampaignProductLink) {
        this.campaign.campaignProductLinks = _.reject(this.campaign.campaignProductLinks, (l) => l.productId === link.productId);
        this.campaignForm.$setDirty();
    }

    public async removeInfotagLink(link: ICampaignInformationCardLink) {
        await this.popupService.confirm({
            classPopup: 'alert--redesign',
            title: this.$translate.instant('delete_infotag_title'),
            content: `<p class="fs-14">${this.$translate.instant('delete_infotag_content')}</p>`
        });
        this.campaign.campaignInformationCardLinks = _.reject(this.campaign.campaignInformationCardLinks, (l) => l.ID === link.ID);
        this.campaignForm.$setDirty();
    }

    public async save() {
        if (!this.accordionOptions.scheduleGroupShow) {
            this.setDefaultSchedule();
        }

        const draftStatusList = [Campaign.EntityStatusEnum.NUMBER_1,
        Campaign.EntityStatusEnum.NUMBER_2, Campaign.EntityStatusEnum.NUMBER_3];

        if (draftStatusList.indexOf(this.campaign.entityStatus as Campaign.EntityStatusEnum) > -1) {
            await this.validateDraftCampaign();
        } else {
            await this.validateCampaign();
        }

        if (this.campaignForm.$invalid) {
            $('html, body').animate({ scrollTop: 0 }, 500);
            return;
        }

        this.saveCampaign();
        this.instanceWysiwygService.deleteRemovedTokens(this.campaign.additionalInfo);
    }

    public async saveCampaign() {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            let campaignID: number;
            if (this.isEdit) {
                campaignID = await this.updateCampaign();
                this.notificationService.clearAll();
            } else {
                campaignID = await this.createCampaign();
                this.notificationService.showSuccessMessage(this.$translate.instant('camapign_created'));
                await this.$timeout(500);
            }
            this.$rootScope.$state.go('app.marketing-campaigns.view', { id: campaignID });

        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;

    }

    public getCampaignStatusModel() {
        this.campaign.statusModel.clear();
        if (this.waiting) {
            return this.campaign.statusModel;
        }

        if (!this.campaign) {
            return null;
        }

        switch (this.campaign.entityStatus) {
            case Campaign.EntityStatusEnum.NUMBER_1:
                this.campaign.statusModel.set(this.campaignStatus.Draft);
                return this.campaign.statusModel;
            case Campaign.EntityStatusEnum.NUMBER_2:
                this.campaign.statusModel.set(this.campaignStatus.AdSubmission);
                return this.campaign.statusModel;
            case Campaign.EntityStatusEnum.NUMBER_3:
                this.campaign.statusModel.set(this.campaignStatus.QualityControl);
                return this.campaign.statusModel;
        }

        if (this.isCompletedCampaignModel()) {
            this.campaign.statusModel.set(this.campaignStatus.Completed);
            return this.campaign.statusModel;
        }

        this.campaign.statusModel = this.getErrorCampaignModel();
        if (this.campaign.statusModel.status === this.campaignStatus.Error) {
            return this.campaign.statusModel;
        }

        this.campaign.statusModel = this.getWarningCampaignModel();
        if (this.campaign.statusModel.status === this.campaignStatus.Warning) {
            return this.campaign.statusModel;
        }

        this.campaign.statusModel = this.isScheduledCampaign();
        if (this.campaign.statusModel.status === this.campaignStatus.Scheduled) {
            return this.campaign.statusModel;
        }

        this.campaign.statusModel = this.isVideoProcessingCampaign();
        if ((this.campaign.statusModel.status === this.campaignStatus.VideoProcessingError) ||
            (this.campaign.statusModel.status === this.campaignStatus.VideoProcessing)) {
            return this.campaign.statusModel;
        }

        this.campaign.statusModel.set(this.campaignStatus.Running);
        return this.campaign.statusModel;
    }

    public isLaunchCampaign = () => {
        return this.campaign.statusModel.status === this.campaignStatus.Running && !this.isEdit;
    }

    public isValidMandatoryFields = () => {
        if (!this.campaign) {
            return true;
        }
        // name
        if (!this.campaign.name || this.campaign.name.length === 0) {
            return false;
        }
        // design
        if (this.campaign.campaignContentType !== 1 && !this.imageCropped.croppedImage && !this.video.videoID) {
            return false;
        } else if (this.imageCropped.croppedImage !== null && this.campaignForm && this.campaignForm.useTemplate) {
            this.validateCampaignImageSize();
            if (this.campaignForm.useTemplate.$error.imageMinAreaSize) {
                return false;
            }
        }
        return true;
    }

    private getErrorCampaignModel = () => {
        if (this.isErrorDesignCampaignModel() || !this.audienceService.validate.audiencePlaceGroup() || !this.audienceService.validate.incompleteGroup()) {
            this.campaign.statusModel.set(this.campaignStatus.Error);
            return this.campaign.statusModel;
        }
        this.campaign.statusModel.set(this.campaignStatus.Undefined);
        return this.campaign.statusModel;
    }

    private getWarningCampaignModel = () => {
        // $scope.statusModel.set($scope.campaignStatus.Warning);
        this.campaign.statusModel.set(this.campaignStatus.Undefined);
        return this.campaign.statusModel;
    }

    private isScheduledCampaign = () => {
        if (this.isScheduledCampaignModel()) {
            this.campaign.statusModel.set(this.campaignStatus.Scheduled);
            return this.campaign.statusModel;
        }
        this.campaign.statusModel.set(this.campaignStatus.Undefined);
        return this.campaign.statusModel;
    }

    private isVideoProcessingCampaign = () => {
        if (this.video && this.video.videoID > 0) {
            if ((this.video.campaignStatus === this.campaignStatus.VideoProcessing) ||
                (this.video.campaignStatus === this.campaignStatus.VideoProcessingError)) {
                this.campaign.statusModel.set(this.video.campaignStatus);
                return this.campaign.statusModel;
            } else {
                if (this.campaign.videoStatus !== this.videoStatus.Processed) {
                    if ((this.campaign.videoStatus === this.videoStatus.Added) ||
                        (this.campaign.videoStatus === this.videoStatus.Uploaded) ||
                        (this.campaign.videoStatus === this.videoStatus.Processing)) {
                        this.campaign.statusModel.set(this.campaignStatus.VideoProcessing);
                        return this.campaign.statusModel;
                    } else {
                        if (this.campaign.videoStatus === this.videoStatus.ProcessingError) {
                            this.campaign.statusModel.set(this.campaignStatus.VideoProcessingError);
                            return this.campaign.statusModel;
                        }
                    }
                }
            }
        }

        return this.campaign.statusModel;
    }

    private setDefaultSchedule = () => {
        this.campaign.schedule = this.campaignsService.getDefaultCampaignSchedule();
    }

    private validateCampaign = async () => {
        this.campaignForm.$pristine = false;
        this.validateCampaignImage();
        this.validateCampaignName();

        this.validateDate();
        this.timeValidation();
        this.validateWeeksday();
        this.validateCampaignKeyword();

        if (await this.validateStickers()) {
            this.campaignForm.$invalid = true;
        }

        if (this.isValidCampaignAudience()) {
            this.campaign.offerAudience = this.audienceService.getOfferAudience();
        }

        this.updateAccordionState();

        if (this.campaignForm.$invalid) {
            this.campaignsService.scrollTop();
        }
    }

    private validateDraftCampaign = async () => {
        this.campaignForm.$pristine = false;
        // validate image
        this.campaignForm.useTemplate.$setValidity('imageRequired', true);
        this.campaignForm.useTemplate.$setValidity('imageMinAreaSize', true);
        this.campaignForm.useTemplate.$setValidity('imageRequired', true);
        if (this.imageCropped.croppedImage !== null) {
            this.validateCampaignImageSize();
        }
        // campaign.name
        this.validateCampaignName();
        // validate template
        this.campaignForm.useTemplate.$setValidity('templateRequired', true);
        this.campaignForm.useTemplate.$setValidity('overflow', true);
        // date
        this.validateDate();
        // time
        this.timeValidation();
        // weeksday
        this.validateWeeksday();
        // audience
        if (this.isValidCampaignAudience()) {
            this.campaign.offerAudience = this.audienceService.getOfferAudience();
        }
        this.updateAccordionState();

        const areStickersValid = await this.validateStickers();
        if (!areStickersValid) {
            this.campaignForm.$invalid = true;
        }

        if (this.campaignForm.$invalid) {
            this.campaignsService.scrollTop();
        }
    }

    private validateStickers = (): Promise<boolean> => {
        this.stickersErrors = [];

        if (!this.campaign.nfcStickers || (this.campaign.nfcStickers && this.campaign.nfcStickers.length === 0)) {
            return this.$q.when(true);
        }

        const STICKER_NUMBER_PATTERN = new RegExp('[A-Z]{1}\\d{12}$');

        let stickersError = false as boolean;
        const duplicatesMap = _.groupBy(this.campaign.nfcStickers, (item) => item.StickerNumber);

        this.campaign.nfcStickers.forEach((sticker, index) => {
            let stickerHasError = false as boolean;
            const stickerError = {
                    id: index,
                    nfcNumber: null,
                    store: null
                } as INfcStickersErrors;

            if (!sticker.StickerNumber) {
                stickerHasError = true;
                stickerError.nfcNumber = this.$translate.instant('nfc_product_stickers_list_sticker_required_error');
            }
            if (sticker.StickerNumber) {
                if (!STICKER_NUMBER_PATTERN.test(sticker.StickerNumber)) {
                    stickerHasError = true;
                    stickerError.nfcNumber = this.$translate.instant('nfc_product_stickers_list_sticker_format_error');
                } else {
                    const duplicates = duplicatesMap[sticker.StickerNumber];
                    if (duplicates && duplicates.length > 1) {
                        stickerHasError = true;
                        stickerError.nfcNumber = this.$translate.instant('sticker_is_already_used');
                    }
                }
            }
            if (!sticker.PlaceID) {
                stickerHasError = true;
                stickerError.store = this.$translate.instant('nfc_product_stickers_list_location_required_error');
            }
            if (stickerHasError) {
                this.stickersErrors.push(stickerError);
                stickersError = true;
            }
        });

        if (stickersError) {
            return this.$q.when(false);
        }

        return this.$q.when(true);
    }

    private updateAccordionState = () => {
        // errors groups
        const form = this.campaignForm;
        const accordion = this.accordionOptions;
        accordion.setupGroupError = form.campaignName.$invalid;
        accordion.designGroupError = form.useTemplate.$invalid;
        accordion.scheduleGroupError = (form.campaignStartDate.$invalid
            || form.campaignStartTime.$invalid
            || form.campaignEndDate.$invalid
            || form.campaignAlertDate.$invalid
            || form.campaignEndTime.$invalid
            || form.datesHasDaily.$invalid);

        accordion.audienceGroupError = form.rules.$invalid;
        accordion.keywordsGroupError = form.keywords.$invalid;

        if (accordion.setupGroupError) {
            accordion.setupGroupOpen = true;
        }

        if (accordion.designGroupError) {
            accordion.designGroupOpen = true;
        }
        if (accordion.scheduleGroupError) {
            accordion.scheduleGroupOpen = true;
        }

        if (accordion.audienceGroupError) {
            accordion.audienceGroupOpen = true;
        }

        if (accordion.keywordsGroupError) {
            accordion.keywordsGroupOpen = true;
        }
    }

    private timeValidation = () => {
        if (!this.campaign.schedule.allDayStart && !this.campaign.schedule.startTime) {
            this.campaignForm.campaignStartTime.$setValidity('invalidTime', false);
        } else {
            this.campaignForm.campaignStartTime.$setValidity('invalidTime', true);
        }

        if (!this.campaign.schedule.allDayEnd && !this.campaign.schedule.endTime) {
            this.campaignForm.campaignEndTime.$setValidity('invalidTime', false);
        } else {
            this.campaignForm.campaignEndTime.$setValidity('invalidTime', true);
        }

        if (!this.campaign.schedule.allDayStart && !this.campaign.schedule.allDayEnd && !this.campaignForm.campaignStartTime.$error.invalidTime && !this.campaignForm.campaignEndTime.$error.invalidTime) {
            const validTime = new Date(this.campaign.schedule.startTime.toString()).setSeconds(0, 0) !== new Date(this.campaign.schedule.endTime.toString()).setSeconds(0, 0);
            this.campaignForm.campaignStartTime.$setValidity('invalidTime', validTime);
            this.campaignForm.campaignEndTime.$setValidity('invalidTime', validTime);
        }
    }

    private async onUpdateCampaignVideoProcessing(event: ng.IAngularEvent, data: ICampaignVideoRetailerMessage) {

        if (this.video && this.video.videoID === data.CampaignVideoID) {
            let doRefresh = false;

            if (event.name === 'CampaignVideoProcessingFinish') {
                this.notificationService.showSuccessMessage(this.$translate.instant('campaign_video_processed_successfully'));
                this.video.campaignStatus = this.campaignStatus.Running;
                this.campaign.videoStatus = this.videoStatus.Processed;
                this.videoManager.processing = false;
                this.videoManager.processed = true;
                doRefresh = true;
            } else if (event.name === 'CampaignVideoProcessingError') {
                this.notificationService.showErrorMessage(this.$translate.instant('campaign_video_processed_error'));
                this.video.campaignStatus = this.campaignStatus.VideoProcessingError;
                this.campaign.videoStatus = this.videoStatus.ProcessingError;
                this.videoManager.processing = false;
                this.videoManager.processingError = false;
                doRefresh = true;
            }

            if (doRefresh && this.campaign && this.campaign.statusModel) {
                this.campaign.statusModel = this.getCampaignStatusModel();
            }
        }
    }
}

angular.module('naut').component('marketingCampaign', {
    template: require('./marketingCampaign.html'),
    controller: CreateEditMarketingCampaignController,
    controllerAs: 'vm',
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/campaigns/components/marketingCampaign/marketingCampaign.component.ts